import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { ReceiptService } from '../../../../services/receipt.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'misc-awb-details',
    templateUrl: './misc-awb-details.component.html',
    styleUrls: ['./misc-awb-details.component.scss']
})
export class MiscAwbDetailsComponent implements OnInit {
    shipmentNumber: string;
    @Output() detailsObject = new EventEmitter();
    @Input() changing;
    amount: any = null;
    comment: any = null;
    @Input() isRequiredShipmentNumber;
    @Input() isRequiredComments;
    @Input() receiptSubTypeId;
    @Input() categoryChanged;
    validateAmount: boolean = false;
    validateComment: boolean = false;
    validateAWB: boolean = false;
    validShipment: any;
    @ViewChild('comt') comt: ElementRef;
    @ViewChild('amt') amt: ElementRef;
    constructor(private shipmentDetails: ReceiptService, private toaster: ToastrService,private translate: TranslateService) {
        this.shipmentNumber = '';
        this.isRequiredShipmentNumber = true;
        this.isRequiredComments = true;
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['changing'] != undefined) {
            var change = changes['changing'].currentValue
            if (change == true)
                this.shipmentNumber = "";
            this.amount = null;
            this.comment = null;
        }
    }

    serachAwbNumber() {
        if (this.receiptSubTypeId == 1 || this.receiptSubTypeId == 3) {
            if (this.shipmentNumber != null && this.shipmentNumber != "") {
                var shipmentsNumbers = this.shipmentNumber.split('\n');
                var AWBNumbers = '';
                for (var i = 0; i < shipmentsNumbers.length; i++) {
                    AWBNumbers += shipmentsNumbers[i] + (i + 1 < shipmentsNumbers.length ? ',' : '');
                }
                this.shipmentDetails.getShipmentDetails(AWBNumbers, 3, false,(res) => {
                    if (this.comt) {
                       this.comt.nativeElement.focus();
                    }
                    //if (this.amt) {
                    //    this.amt.nativeElement.focus();
                    //}
                    this.validShipment = res.filter((x) => { return x.Shipment != null });
                    var inValidShiments = res.filter((x) => { return x.IsReady == false });
                    res.filter(x => x.Shipment != null)
                    if (inValidShiments.length > 0) {
                        this.detailsObject.emit(null);
                        this.validateAWB = false;
                        for (var i = 0; i < inValidShiments.length; i++) {
                            this.toaster.error(`${this.translate.instant('pages.createReceiptPage.miscAwb.shipmentNumberNotReady',{
                                inValidShimentsNumber: inValidShiments[i].Number
                              })}`);
                        }
                    }
                    else {
                        this.validateAWB = false;
                        if (this.validateAll() && this.validShipment) {
                            if (this.validShipment.length > 0)
                                this.detailsObject.emit({ shipments: this.validShipment, amount: this.amount, comment: this.comment });
                            else
                                this.detailsObject.emit(null);
                        }
                        else {
                            if (this.receiptSubTypeId == 3) {
                                this.amt.nativeElement.focus();
                            }
                        }
                    }

                }, (err) => {
                });
            }
            else {
                this.validateAWB = true;
            }
        }
    }

    validateAndEmitComment() {
        var inValidComment = (this.comment == null || this.comment == "");
        if (inValidComment) {
            this.validateComment = true;
            this.detailsObject.emit(null);
        }
        else {
            this.validateComment = false;
        }
        if (!inValidComment) {
            this.validateComment = false;
            if (this.validateAll() && this.validShipment)
                if (this.validShipment.length > 0)
                    this.detailsObject.emit({ shipments: this.validShipment, amount: this.amount, comment: this.comment });
                else
                    this.detailsObject.emit(null);
        }
    }

    validateAndEmitAmount() {
        var inValidAmount = (this.amount == null || this.amount == "");
        if (inValidAmount) {
            this.validateAmount = true;
            this.detailsObject.emit(null);
        }
        else {
            this.validateAmount = false;
        }
        if (!inValidAmount) {
            this.validateAmount = false;
            if (this.validateAll())
                if (this.validShipment) {
                    if (this.validShipment.length > 0)
                        this.detailsObject.emit({ shipments: this.validShipment, amount: this.amount, comment: this.comment });
                    else
                        this.detailsObject.emit(null);
                }
                else {
                    this.detailsObject.emit({ shipments: null, amount: this.amount, comment: this.comment });
                }
        }
    }

    validateAll() {
        var validAWB = (this.receiptSubTypeId == 1 || this.receiptSubTypeId == 3) ? (this.shipmentNumber != null && this.shipmentNumber != "") : true;
        var validComment = (this.receiptSubTypeId == 1 || this.receiptSubTypeId == 2) ? (this.comment != null && this.comment != "") : true;
        var validAmount = (this.amount != null && this.amount != "");
        if ((!this.validateAWB && !this.validateComment && !this.validateAmount) && validAmount && validComment && validAWB) {
            return true;
        }
        else {
            return false;
        }
    }
    ngOnInit() {

    }
}
